import { MdArrowForwardIos } from "react-icons/md";

function FitButtons(props) {
  let styles = " px-6 py-2 rounded-md text-[10px] w-fit active:bg-t-bk";
  let stylesbig =
    "text-p-wh px-6 py-3 text-[30px] rounded-md w-fit active:bg-t-bk";
  let stylesbigc =
    "text-p-bk px-6 py-3 text-[30px] rounded-md w-fit active:bg-t-bk";
  let blue = "bg-b-mc ";
  let red = "bg-red-500";
  let green = "bg-green-500";
  let orange = "bg-orange-500";
  let cancel = "bg-s-bk ";
  let buttonStyle;
  switch (props.color) {
    case "blue":
      buttonStyle = `${styles} ${blue}`;
      break;
    case "red":
      buttonStyle = `${styles} ${red}`;
      break;
    case "green":
      buttonStyle = `${styles} ${green}`;
      break;
    case "orange":
      buttonStyle = `${styles} ${orange}`;
      break;
    case "bigblue":
      buttonStyle = `${stylesbig} ${blue}`;
      break;
    case "cancel":
      buttonStyle = `${stylesbigc} ${cancel}`;
      break;
    default:
      buttonStyle = "text-p-wh px-4 py-2.5 w-full bg-b-mc rounded-lg";
      break;
  }
  return (
    <button className={buttonStyle} onClick={props.onClick}>
      <div className="flex flex-row gap-4 items-center w-fit justify-center">
        <p className="text-p-wh text-xs">{props.details}</p>
        {props.icon ? (
          <div className="rounded-md text-p-wh hover:text-p-wh hover:bg-b-mc">
            <MdArrowForwardIos />
          </div>
        ) : (
          ""
        )}
      </div>
    </button>
  );
}
// Button.propTypes = {};
export default FitButtons;
